import { useEffect } from 'react';

const SCROLL_POSITION_KEY = 'marathi-proverbs-scroll-position';
const SCROLL_TIMESTAMP_KEY = 'marathi-proverbs-scroll-timestamp';
const RESTORE_TIMEOUT = 1000 * 60 * 30; // 30 minutes

export const useScrollPosition = () => {
  useEffect(() => {
    // Restore scroll position on mount (if recent)
    const savedPosition = localStorage.getItem(SCROLL_POSITION_KEY);
    const savedTimestamp = localStorage.getItem(SCROLL_TIMESTAMP_KEY);

    if (savedPosition && savedTimestamp) {
      const timestamp = parseInt(savedTimestamp, 10);
      const now = Date.now();

      // Only restore if less than 30 minutes old
      if (now - timestamp < RESTORE_TIMEOUT) {
        const position = parseInt(savedPosition, 10);
        // Use setTimeout to ensure DOM is ready
        setTimeout(() => {
          window.scrollTo({
            top: position,
            behavior: 'auto', // Instant restore, not smooth
          });
        }, 100);
      } else {
        // Clear old data
        localStorage.removeItem(SCROLL_POSITION_KEY);
        localStorage.removeItem(SCROLL_TIMESTAMP_KEY);
      }
    }

    // Save scroll position on unmount
    const saveScrollPosition = () => {
      const position = window.scrollY;
      const timestamp = Date.now();
      localStorage.setItem(SCROLL_POSITION_KEY, position.toString());
      localStorage.setItem(SCROLL_TIMESTAMP_KEY, timestamp.toString());
    };

    // Save on page unload
    window.addEventListener('beforeunload', saveScrollPosition);

    // Cleanup
    return () => {
      window.removeEventListener('beforeunload', saveScrollPosition);
    };
  }, []);
};
